import React from 'react';
import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const OrderSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get('orderId');
  const ivrId = searchParams.get('ivrId');
  const isEdit = searchParams.get('action') === 'edit';

  return (
    <Box maxW="600px" mx="auto" mt={20} p={6} textAlign="center" borderWidth="1px" borderRadius="xl">
      <VStack spacing={6}>
        <Heading color="green.500">
          {isEdit ? '✅ Order Updated' : '✅ Order Created'}
        </Heading>
        <Text fontSize="lg">
          Order ID: <strong>{orderId}</strong>
        </Text>
        <Button colorScheme="teal" onClick={() => navigate(`/admin/ivrstatus?ivr=${ivrId}`)}>
          Go to IVR Status Page
        </Button>
      </VStack>
    </Box>
  );
};

export default OrderSuccessPage;